import { FORMAT_DATE } from '@/utils'

export default FORMAT_DATE
